<template>
  <div class="page-content" :style="defaultHeight" id="page-content">
    <div class="startTitle">健康档案</div>
    <el-row>
      <el-col :span="4">
        <div class="grid-content">
          <el-upload v-if="isTxShow" :action="imgAction" :http-request="uploadImg" :multiple="false" name="img" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
            <img class="datatx_img" v-if="imageUrl" :src="imageUrl">
            <div v-else class="txBox">
              <img src="../../assets/images/back/defTx.png" alt="">
            </div>
            <p class="modify-avatar">修改头像</p>
          </el-upload>
        </div>
      </el-col>
      <el-col :span="20" style="padding-left: 28px">
        <div class="grid-content">
          <h3 class="title-h3">基本信息</h3>
          <!----------------------------------------------------------->
          <el-row>
            <el-col :span="6">
              <div class="sub-title">姓名</div>
              <el-input placeholder="请输入" v-model="memberName"></el-input>
            </el-col>
            <el-col :span="6" :offset="2">
              <div class="sub-title">昵称</div>
              <el-input placeholder="请输入" v-model="nicheng"></el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <div class="sub-title">手机号</div>
              <el-input v-model="phone" :disabled="false"></el-input>
            </el-col>
             <!--<el-col :span="6" :offset="2">
              <el-button type="info" class="form-mt32 dmh-greybtn">更改手机号</el-button> 
            </el-col>-->
            <el-col :span="6" :offset="2">
              <div class="sub-title">过敏史</div>
              <!--              :props="props"-->
              <el-cascader v-model="form.historyOfAllergy" :options="allergenList" :props="props" collapse-tags style="width:100%"></el-cascader>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <div class="sub-title">出生日期</div>
              <el-date-picker v-model="birthday" type="date" placeholder="选择日期">
              </el-date-picker>
            </el-col>
            <el-col :span="6" :offset="2">
              <div class="sub-title">性别</div>
              <el-radio-group v-model="gender">
                <el-radio label="男"></el-radio>
                <el-radio label="女"></el-radio>
              </el-radio-group>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <div class="sub-title">身高</div>
              <el-input placeholder="请输入" v-model="height">
                <i slot="suffix" class="suffixText">CM</i>
              </el-input>
            </el-col>
            <el-col :span="6" :offset="2">
              <div class="sub-title">体重</div>
              <el-input placeholder="请输入" v-model="weight">
                <i slot="suffix" class="suffixText">kg</i>
              </el-input>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <div class="sub-title">职业</div>

          <!--     <el-form-item label="职业" prop="education">
              <el-select v-model="form.profession" placeholder="请选择" clearable style="width:100%">
               <el-option v-for="item in industryTypezhiye"
                  :key="item.id"
                  :label="item.tradeCategory"
                  :value="item.tradeCategory">
                </el-option>
              </el-select>
            </el-form-item> -->


              <el-select placeholder="请输入" v-model="zhiye">
                <el-option v-for="item in getIndustryList_3" :label="item.tradeCategory" :value="item.tradeCategory" :key="item.id"></el-option>
              </el-select>
            </el-col>
            <el-col :span="6" :offset="2">
              <div class="sub-title">教育</div>
              <el-select placeholder="请输入" v-model="education">
                <el-option v-for="item in getIndustryList_4" :label="item.tradeCategory" :value="item.tradeCategory" :key="item.id"></el-option>
              </el-select>
            </el-col>
          </el-row>
          <el-row>
            
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-button type="success" class="btn-save dmh-colbtn" @click="submitAjax">保存</el-button>
            </el-col>
          </el-row>

          <!----------------------------------------------------------->
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import '@/assets/css/backcommon.css'
import {
  updateProfile,
  getAllergen
} from '@/api/user';
import { Notification } from 'element-ui'
import {
  uploadImg,
  mechanismGetIndustryList
} from '@/api/myInfo';
import baseAPI from "@/api/baseAPI";


export default {
  name: "healthRecords",
  data () {
    return {
      isTxShow: false,
      userId: '',
      defaultHeight: {
        height: ""
      },
      from: {
        name: ""
      },
      getIndustryList_3:[],
      getIndustryList_4:[],
      imageUrl: "",
      memberName: "",
      nicheng: "",
      phone: "",
      birthday: "",
      gender: "男",
      height: "",
      weight: "",
      zhiye: "",
      education: "",
      //过敏史
      form: {
        historyOfAllergy: ''
      },
      props: { multiple: true },

      allergenList: null,
      allergenData: null,
      getGmdata: "",
      //文件上传的参数
      //图片列表（用于在上传组件中回显图片）
      fileList: [],
      // 图片上传地址
      imgAction: null,
    }
  },
  watch: {
    "$route": {
      handler (to, from) {
        setTimeout(() => {
          this.showUserData();
        }, 500)
      },
      immediate: true
    }
  },
  mounted () {
    //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
    window.addEventListener("resize", this.getHeight);
    this.userId = this.$store.state.user.userId;
    if (this.userId == "") {

      var ths = this;
      setTimeout(function () {
        ths.userId = JSON.parse(Cookies.get("userInfo"))["userId"];
      }, 2000);
    }
    this.getHeight();
    this.getAllergenList();
    this.mechanismGetIndustryList();
    this.getImgAction()

  },
  methods: {
    //------------------------------------------------------------------------------------
    //定义方法，获取高度减去头尾
    getHeight () {
      this.defaultHeight.height = document.getElementById("page-content") - 105 + "px";
    },
    handleExceed (files, fileList) {
      // :on-exceed="handleExceed"
      // this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    // 赋值文件上传路径
    getImgAction () {
      let _this = this;
      // _this.imgAction = process.env.VUE_APP_BASE_API + '/device/product/uploadImg';
      _this.imgAction = baseAPI + '/device/product/uploadImg';
    },
    handleAvatarSuccess (res, file) {
      this.message({
        type: 'info',
        message: '图片上传成功',
        duration: 6000
      });
      // this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload (file) {
      const isJPG = file.type == 'image/jpeg';
      const isGIF = file.type == 'image/gif';
      const isPNG = file.type == 'image/png';
      const isBMP = file.type == 'image/bmp';
      const isLt2M = file.size / 1024 / 1024 < 5;

      if (!isJPG && !isGIF && !isPNG && !isBMP) {
        this.$message.error('上传图片必须是JPG/GIF/PNG/BMP 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 5MB!');
      }
      return (isJPG || isBMP || isGIF || isPNG) && isLt2M;
    },
    uploadImg (query) {
      let ths = this;
      let param = new FormData();
      param.append('img', query.file);
      uploadImg(param).then(response => {
        if (parseInt(response.data.code) == 200) {
          ths.imageUrl = response.data.data; //将返回的文件储存路径赋值picture字段
          // this.form.projectContractName = response.fileName;
          Notification({
            title: response.data.msg,
            type: 'success'
          });
        }
      })
    },
    changeTime (time) {
      var d = new Date(time);
      return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate()
    },

    //职业3和教育4
    mechanismGetIndustryList () {
      mechanismGetIndustryList(3).then(response => {
        console.log(response.data.data,'参数');
        this.getIndustryList_3 = response.data.data;
      });
      mechanismGetIndustryList(4).then(response => {
        this.getIndustryList_4 = response.data.data;
      });
    },
    showUserData () {
      // realname  是姓名  ，username是昵称
      var userData = this.$store.state.user;
      console.log(userData)
      this.imageUrl = userData.info.picImg;
      this.memberName = userData.info.realName;
      this.nicheng = userData.info.userName;
      this.phone = userData.info.phone;
      this.birthday = userData.info.birthday;
      this.gender = userData.info.sex == "1" ? "男" : "女";
      this.height = userData.info.userHeight;
      this.weight = userData.info.userWeight;
      if (userData.info.historyOfAllergy != null) {
        this.form.historyOfAllergy = this.set_historyOfAllergy(JSON.parse(userData.info.historyOfAllergy));
      }
      if (userData.info.education != undefined && userData.info.education != null) {
        // this.education = parseInt(userData.info.education);
        this.education = userData.info.education;
      }
      if (userData.info.profession != undefined && userData.info.profession != null) {
        // this.zhiye = parseInt(userData.info.profession);
        this.zhiye = userData.info.profession;
      }
      this.isTxShow = true;
      this.$forceUpdate();
    },
    submitAjax () {
      var ths = this;
      if (this.memberName == "") {
        this.message("请输入姓名");
        return;
      }
      if (this.nicheng == "") {
        this.message("请输入昵称");
        return;
      }
      if (this.birthday == "") {
        this.message("请输入出生日期");
        return;
      }
      if (this.gender == "") {
        this.message("请输入性别");
        return;
      }
      if (this.height == "") {
        this.message("请输入身高");
        return;
      }
      if (this.weight == "") {
        this.message("请输入体重");
        return;
      }
      if (this.zhiye == "") {
        this.message("请输入职业");
        return;
      }
      if (this.education == "") {
        this.message("请输入教育");
        return;
      }
      if (this.form.historyOfAllergy == "") {
        this.message("请选择过敏史");
        return;
      }
      updateProfile({
        id: this.userId,
        picImg: this.imageUrl,
        realName: this.memberName,
        userName: this.nicheng,
        phone: this.phone,
        birthday: this.changeTime(this.birthday),
        sex: this.gender == "男" ? "1" : "2",
        userHeight: this.height,
        userWeight: this.weight,
        profession: this.zhiye,
        education: this.education,
        historyOfAllergy: this.submit_historyOfAllergy(this.form.historyOfAllergy)
      }).then(res => {
        if (parseFloat(res.data.code) == 200) {
          ths.message("提交成功", 'success');
          ths.$store.dispatch("GetInfo");
        } else {
          ths.message(res.data.msg);
        }
      })
    },
    // 对用户过敏原数据进行处理
    getUserAllergenList (res) {
      var data = JSON.parse(res);
      var allergenArray = [];
      var historyOfAllergy = [];
      for (var i = 0; i < data.length; i++) {
        var a = []
        for (var j = 0; j < data[i].userAllergensList.length; j++) {
          var b = { "value": j, "label": data[i].userAllergensList[j].name };
          a.push(b)
          var history = [];
          if (data[i].userAllergensList[j].status == 1) {
            history.push(i);
            history.push(j);
            historyOfAllergy.push(history);
          }
        }
        var c = { "value": i, "label": data[i].name, "children": a };
        allergenArray.push(c);
      }
      this.allergenList = allergenArray;
      return historyOfAllergy;
    },
    set_historyOfAllergy (data) {
      var arr = [];
      if (data.length == 0 || data == undefined || data == null) {
        return '';
      }
      for (var i = 0; i < data.length; i++) {
        var item = data[i]
        for (var ii = 0; ii < item.userAllergensList.length; ii++) {
          var itemObj = item.userAllergensList[ii];
          if (parseInt(itemObj.status) == 1) {
            arr.push([data[i].name, itemObj.name])
          }
        }
      }
      if (arr.length == 0) {
        return '';
      }
      return arr;
    },
    submit_historyOfAllergy (actdata) {
      var getGmdata = this.getGmdata;
      for (var i = 0; i < actdata.length; i++) {
        for (var j = 0; j < getGmdata.length; j++) {
          var item = getGmdata[j];
          if (item.name == actdata[i][0]) {
            for (var iii = 0; iii < item.userAllergensList.length; iii++) {
              if (actdata[i][1] == item.userAllergensList[iii].name) {
                item.userAllergensList[iii].status = 1
              }
            }
          }
        }
      }
      return JSON.stringify(getGmdata);
    },
    // 获取过敏原
    getAllergenList () {
      getAllergen().then(response => {
        // if (value == 1) {
        //     this.allergenData = response.data;
        // } else {
        this.getGmdata = response.data.data;
        var allergenArray = [];
        for (var i = 0; i < response.data.data.length; i++) {
          var a = []
          for (var j = 0; j < response.data.data[i].userAllergensList.length; j++) {
            var b = { "value": response.data.data[i].userAllergensList[j].name, "label": response.data.data[i].userAllergensList[j].name };
            a.push(b)
          }
          var c = { "value": response.data.data[i].name, "label": response.data.data[i].name, "children": a };
          allergenArray.push(c);
        }
        this.allergenList = allergenArray;
        // }
      });
    },
  },
}
</script>

<style scoped>
.el-row {
  margin-bottom: 10px;
}
.el-radio-group {
  position: relative;
  top: 3px;
}
.btn-save {
  margin-top: 20px;
  width: 160px;
  height: 40px;
  background: #13c76b;
  border-radius: 4px;
  border-color: #12c76b;
}

.modify-avatar {
  width: 160px;
  cursor: pointer;
  font-size: 16px;
  color: #5e6d82;
  line-height: 40px;
  text-align: center;
}
.form-mt32 {
  margin-top: 32px;
  background-color: #596880;
}
.txBox {
  position: relative;
  background-color: #14c86c;
  width: 160px;
  height: 160px;
  line-height: 160px;
  /*text-align: center;*/
}
.datatx_img {
  position: relative;
  width: 160px;
  height: 160px;
  line-height: 160px;
  /*text-align: center;*/
}
.txBox img {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 90px;
  height: 90px;
  line-height: 90px;
  margin-top: -45px;
  margin-left: -45px;
}
</style>



// WEBPACK FOOTER //
// src/views/personCenter/healthRecords.vue